import { atom } from 'recoil';
import { CartType } from '~/types';

const cartType = atom({
  key: 'cartType',
  default: CartType.PERSONAL,
});

export default cartType